export default {
  // 国内：正式环境：ota.rayneo.cn测试环境：ota-test.rayneo.cn  暂时先没有海外

  tadPath:
    location.hostname === "ota.rayneo.com"
      ? "https://hw-tdp-o.api.leiniao.com"
      : location.hostname === "ota-hw-test.rayneo.cn"
      ? "https://tdp-t.api.leiniao.com"
      : location.hostname === "localhost"
      ? ""
      : "https://tdp-t.api.leiniao.com",
  xrlauncherPath:
    location.hostname === "ota.rayneo.com"
      ? "https://hwxr-o.api.leiniao.com"
      : location.hostname === "ota-hw-test.rayneo.cn"
      ? "https://test-xr-launcherapi.rayneo.cn"
      : location.hostname === "localhost"
      ? ""
      : "https://test-xr-launcherapi.rayneo.cn",
  path:
    location.hostname === "ota.rayneo.cn"
      ? "https://rayneo.cn"
      : location.hostname === "ota-test.rayneo.cn"
      ? "https://test.rayneo.cn"
      : location.hostname === "localhost"
      ? ""
      : "https://test.rayneo.cn",
};
